/*
 * `DES-001`. The page frame, card, hints and errors moved to the shared
 * `customer/CustomerPage.module.css`; the version history moved to `ui/Table`.
 * What remains is this screen's own.
 */
.cardTitle {
  font-family: var(--font-display);
  font-size: 1rem;
  margin: 0;
}

/*
 * The current active version is the single most consequential fact on this
 * screen — it is what prices every quote right now — and it was a muted grey
 * hint sitting above a white card that drew all the attention.
 */
.current {
  background: var(--card);
  border: 1px solid var(--line);
  border-left: 3px solid var(--teal-500);
  border-radius: var(--radius-sharp);
  padding: 0.75rem 1rem;
  margin: 0 0 1.5rem;
  font-size: var(--text-min-body);
}

.currentLabel {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--ink-soft);
  text-transform: uppercase;
  letter-spacing: 0.02em;
  display: block;
  margin-bottom: 0.25rem;
}

.currentNone {
  border-left-color: var(--warn);
  color: var(--ink);
}

/*
 * The replace gate. `SPEC-LGH-003 §1` puts "someone must confirm it replaced
 * the previous one" at the centre of this screen's reason to exist, and it
 * rendered as a 13px native checkbox beside a line of amber text, wedged
 * between two ordinary fields — the visual weight of a fine-print disclaimer.
 */
.acknowledge {
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  padding: 0.75rem 1rem;
  border: 1px solid var(--warn);
  border-radius: var(--radius-sharp);
  background: color-mix(in srgb, var(--warn) 7%, var(--card));
  font-size: var(--text-min-body);
  color: var(--ink);
  cursor: pointer;
}

.acknowledge input {
  /* 13px native default — under any reasonable touch target. */
  width: 1.125rem;
  height: 1.125rem;
  margin: 0;
  flex: 0 0 auto;
  accent-color: var(--warn);
}

.result {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.refusedList {
  margin: 0;
  padding-left: 1.25rem;
  color: var(--ink);
  font-size: var(--text-min-mono);
}

.refusedList li {
  margin-bottom: 0.125rem;
}

.refusedMore {
  color: var(--muted);
  font-size: var(--text-min-mono);
  margin: 0.25rem 0 0;
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  white-space: nowrap;
}

.fileName {
  word-break: break-all;
}
